import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const BillingPage = lazy(() => import('./pages/BillingPage'));

export const ROUTES = [
    {
        path: '/billing',
        element: (
            <Suspense fallback={<Spinner block />}>
                <BillingPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
